import { render } from "./EcomTabPane.vue?vue&type=template&id=277a349b"
import script from "./EcomTabPane.vue?vue&type=script&lang=js"
export * from "./EcomTabPane.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/globals/UI/Tab/EcomTabPane.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "277a349b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('277a349b', __exports__)) {
    api.reload('277a349b', __exports__)
  }
  
  module.hot.accept("./EcomTabPane.vue?vue&type=template&id=277a349b", () => {
    api.rerender('277a349b', render)
  })

}


export default __exports__